import { Button, DialogActions, DialogContent } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TbHistory } from "react-icons/tb";

import CommonPopup from "@/components/CommonPopup";
import { HotelClinicTaskResolved } from "@/pages/HotelPlanning/clinic-arrival/types";
import {
    useClinicArrivalTaskStatusHistoryTaskId,
    useClinicArrivalTasksGridActions,
} from "@/stores/use-clinic-arrival-tasks-grid";

import { HotelClinicTaskMilestonesTimeline } from "./HotelClinicTaskStatusMilestonesModal";

export default function ClinicArrivalTaskStatusHistoryDialog({ tasks }: { tasks: HotelClinicTaskResolved[] }) {
    const { t } = useTranslation();
    const taskId = useClinicArrivalTaskStatusHistoryTaskId();
    const { updateTaskStatusHistoryTaskId } = useClinicArrivalTasksGridActions();

    const task = useMemo(() => tasks.find((r) => r.id === taskId), [tasks, taskId]);

    const onClose = () => updateTaskStatusHistoryTaskId();

    return (
        <CommonPopup
            title={t("hotelClinicStatuses.historyDialogTitle")}
            icon={TbHistory}
            open={!!taskId}
            size="md"
            onClose={onClose}
        >
            <div>
                <DialogContent dividers className="max-h-[min(520px,70vh)] overflow-y-auto">
                    {task?.statusMilestones ? (
                        <HotelClinicTaskMilestonesTimeline statusMilestones={task.statusMilestones} />
                    ) : (
                        <p className="text-sm text-gray-500 py-2">{t("hotelClinicStatuses.noMilestoneData")}</p>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="secondary" variant="outlined">
                        {t("buttons.close")}
                    </Button>
                </DialogActions>
            </div>
        </CommonPopup>
    );
}
